import layoutBase from '../layout-base.js';
import Vue from 'vue';
import './layout.scss';
import mhap from '../../modules/MHAP/mhap';
import mstb from '../../modules/MSTB/mstb';
import mvtu from '../../modules/MVTU/mvtu';
import '../../applications/search/search.js';
new Vue({
	extends: layoutBase,
	components: {
		mhap,
		mstb,
		mvtu
	}
}).$mount('[data-layout-id="AELO-app"]');
